import { render, staticRenderFns } from "./cobranca.vue?vue&type=template&id=74241f8e"
import script from "./cobranca.ts?vue&type=script&lang=js&external"
export * from "./cobranca.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74241f8e')) {
      api.createRecord('74241f8e', component.options)
    } else {
      api.reload('74241f8e', component.options)
    }
    module.hot.accept("./cobranca.vue?vue&type=template&id=74241f8e", function () {
      api.rerender('74241f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/cobranca.vue"
export default component.exports